// removed by extract-text-webpack-plugin
module.exports = {"careers":"src-components-Careers----Careers-module---careers---271R8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Careers/Careers.module.css
// module id = 204
// module chunks = 70144966829960 263791100135453